module.exports = __webpack_public_path__ + "img/translationeditor_18.9c1038b6.jpg";